import MediaQuery from 'react-responsive';
import VideoIntersection from '../components/videoIntersection';

const laptopVideo = "/ReactAssets/CustomerJourney/KITCHEN_MAIN.mp4";
const loadingPoster = '/ReactAssets/CustomerJourney/loading.gif';
function FindAPLace({animate}) {
   return(
      <div className="flex inspiring">
         <div className="col-1/2">
            <VideoIntersection 
            animate={animate} 
            poster={loadingPoster}
            src={laptopVideo} 
            loop/>
         </div>
         <div className="col-1/2 content">
            <h2>An inspiring blank canvas</h2>
            <p>Grab a cup of tea, get comfy on your couch and spend some time with our options visualiser.  This digital tool will help you get a feel for the style of kitchen and bathroom finishes you could choose in your new home. Remember, the earlier in the build process you reserve, the more of your home you can personalise, it’s time to have fun and start bringing your interior dreams to life.</p>
            <a href="/what-makes-us-different/options-and-extras.aspx" class="btn btn-primary">Visualise my options</a>
         </div>
      </div>
   )
}

export default FindAPLace;